import React from "react";

import { Link } from "@at/design-system-elements";
import { TypeFiesta } from "@at/design-system-foundation";

import * as Styles from "../leasing-modal-hub.styled";

export const LeasingRoadTaxModal = () => {
  return (
    <>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalHeader>
          Road tax and roadside assistance
        </Styles.LeasingProductModalHeader>
        <Styles.LeasingProductModalParagraph>
          When you lease with Auto Trader, you get your road tax included in the
          price you pay, plus you&apos;ll also get free roadside assistance for
          your entire lease period.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          So that&apos;s two more hassles taken care of!
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalSubHeader>
          Road tax included
        </Styles.LeasingProductModalSubHeader>
        <Styles.LeasingProductModalParagraph>
          Normally when you buy a vehicle, you need to arrange road tax yourself
          by contacting the DVLA.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          But when you lease a vehicle with us, rather than buy, we&apos;ll
          organise your road tax for you. The cost is built into your monthly
          lease payments, so you only pay one easy amount.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalInfoBlock>
          <Styles.LeasingProductModalParagraph>
            <TypeFiesta weight="600" as="span">
              Good to know:
            </TypeFiesta>{" "}
            Sometimes the government may raise or lower the &apos;Road Fund
            Licence&apos; (RFL), which affects how much road tax costs, partway
            through your lease agreement.
          </Styles.LeasingProductModalParagraph>
          <Styles.LeasingProductModalParagraph>
            If this happens, you may need to pay a little extra (or you may get
            some money back if the RFL goes down).
          </Styles.LeasingProductModalParagraph>
        </Styles.LeasingProductModalInfoBlock>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
      <Styles.LeasingProductModalHeaderAndParagraphContainer>
        <Styles.LeasingProductModalSubHeader>
          Roadside assistance
        </Styles.LeasingProductModalSubHeader>
        <Styles.LeasingProductModalParagraph>
          An added bonus to make driving your brand-new lease vehicle even
          smoother.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          Your lease vehicle will come with free roadside assistance included,
          which is provided by the manufacturer of the vehicle.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          The amount of cover you get may vary between manufacturers. The
          majority offer a minimum of three years roadside assistance, but you
          can ask a member of our team for the exact amount of cover you will
          get for your vehicle.
        </Styles.LeasingProductModalParagraph>
        <Styles.LeasingProductModalParagraph>
          Want to know more?{" "}
          <Link
            href="https://www.autotrader.co.uk/terms-and-conditions/vanarama"
            routerLink={false}
            attributes={{
              target: "_blank",
            }}
          >
            Read our Terms and Conditions
          </Link>{" "}
          for all the legal bits.
        </Styles.LeasingProductModalParagraph>
      </Styles.LeasingProductModalHeaderAndParagraphContainer>
    </>
  );
};
